var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVideoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 12,
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.75
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.389.027h11.523a1.39 1.39 0 0 1 1.39 1.39v9.14a1.39 1.39 0 0 1-1.39 1.388H1.39A1.39 1.39 0 0 1 0 10.556v-9.14A1.39 1.39 0 0 1 1.389.027ZM5.5 8.598 10 6 5.5 3.402v5.196Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.227 7.89 20 10.494V1.51l-4.773 2.606v3.774Z"
}))));
export { SvgVideoIcon as ReactComponent };
export default __webpack_public_path__ + "11736b7a7d1d80fb7e5e246471759bba.svg";